<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.social_service.new')"
            back
        />
        <v-row>
            <v-col cols="12">
                <SocialServiceForm
                    :data="data"
                    :raw-data="rawData"
                    :errors="formErrors"
                    :save-function="saveObject"
                    :discard-function="resetObject"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import PageHeader from '@/components/common/PageHeader';
import OfficeForm from '@/components/office/Form/OfficeForm.vue';
import SocialServiceProxy from '@/proxies/SocialServiceProxy';
import { StandBy, SuccessSnackbar } from '@/app-events.js';

export default {
    name: 'SocialServiceNew',
    components: {
        PageHeader,
        SocialServiceForm: OfficeForm,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.social_service.title'),
                    exact: true,
                    to: { name: 'social_service' },
                },
                {
                    text: this.$t('general.new'),
                    disabled: true,
                },
            ],
            data: {
                canton: {},
            },
            rawData: {
                canton: {},
            },
        };
    },
    methods: {
        resetObject() {
            this.data = JSON.parse(JSON.stringify(this.rawData));
            this.resetErrors();
        },
        saveObject() {
            if (JSON.stringify(this.data) === JSON.stringify(this.rawData)) {
                return;
            }
            this.$eventBus.dispatch(new StandBy(true));
            const formData = {
                social_service: {
                    officeName: this.data.office_name,
                    address: this.data.address,
                    zip: this.data.zip,
                    city: this.data.city,
                    officePhone: this.data.office_phone,
                    fax: this.data.fax,
                    memo: this.data.memo,
                    firstname: this.data.firstname,
                    lastname: this.data.lastname,
                    phone: this.data.phone,
                    email: this.data.email,
                    canton: this.data.canton.code,
                },
            };
            new SocialServiceProxy().new(formData).then(({ data }) => {
                this.$eventBus.dispatch(new StandBy(false));
                this.$eventBus.dispatch(new SuccessSnackbar(this.$t('social_service.actions.created')));
                this.$router.push({ name: 'social_service_detail', params: { id: data.data.id } });
            }).catch(({ data }) => {
                this.processErrors(data);
                this.$eventBus.dispatch(new StandBy(false));
            });
        }
    },
};
</script>
